/* em-nozoom.js v1 (28/10/2026, Claude) – thay em-zoom.js: TẮT zoom trình thiết kế + giữ khung ảnh mobile cố định.
 * Lỗi 28/10: trên mobile, cuộn bảng thiết kế làm khung ảnh co/giãn liên tục 337↔227px (class tt-cv-sm của em-tts-fix
 * + resize) → giật; zoom (em-zoom) không hiệu quả. Cách sửa: không nạp em-zoom; khung ảnh luôn min(100vw,40vh);
 * ẩn nút/gợi ý zoom; ép zoom = 1 (chữ thêu, thêu ảnh) → watermark giữ một mật độ cố định. */
(function () {
  if (window.__emNoZoom) return; window.__emNoZoom = 1;
  var st = document.createElement('style');
  st.setAttribute('data-em-nozoom', '');
  st.textContent =
    'html.em-tts body .dmc-modal.tt-cv-sm:not(.is-confirm) .dmc-stage,html.em-tts body .dmp-modal.tt-cv-sm:not(.is-confirm) .dmp-stage{--cv:min(100vw,40vh)!important}' +
    'html.em-tts body .dmc-modal .dmc-tools>button.dmc-tool.dmc-tool--zoom,html body .dmc-modal .dmc-tools>button.dmc-tool.dmc-tool--zoom,html body .dmp-modal .dmp-tools>button.dmp-tool.dmp-tool--zoom,html.em-tts body .dmp-modal .dmp-tools>button.dmp-tool.dmp-tool--zoom,html body .dmc-modal button.dmc-zoomhint,html body .dmp-modal button.dmp-zoomhint,html body .dmc-modal .tt-zchip{display:none!important}';
  (document.head || document.documentElement).appendChild(st);
  function unzoom(P) {
    if (!P || P.__emNZ) return !!(P && P.__emNZ);
    P.__emNZ = 1;
    var sz = P.setZoom;
    if (typeof sz === 'function') P.setZoom = function () { var a = [].slice.call(arguments); a[0] = 1; return sz.apply(this, a); };
    if (typeof P.dmcAutoZoom === 'function') P.dmcAutoZoom = function () {};
    return true;
  }
  function patch() {
    var D = window.DearEmCustomizer, ok = !!(D && D.Customizer && unzoom(D.Customizer.prototype));
    var PD = window.DearEmPhotoCustomizer; if (PD && PD.Customizer) unzoom(PD.Customizer.prototype);
    return ok;
  }
  var n = 0, iv = setInterval(function () { if (patch() || ++n > 150) clearInterval(iv); }, 200);
  patch();
  /* đang zoom sẵn (mở lại bản nháp đã zoom) → trả về 1 */
  setInterval(function () {
    var m = document.querySelector('.dmc-modal.is-open.is-zoomed, .dmp-modal.is-open.is-zoomed');
    if (!m) return;
    var c = m.closest('[data-dearem-customizer]') || document.querySelector('[data-dearem-customizer]');
    var inst = c && c.__dmc;
    if (inst && inst.zoom > 1 && inst.setZoom) inst.setZoom(1);
  }, 400);
})();
